import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary';
import { GlobalErrorFallback, logError, resetErrorBoundary } from '@libs/utils/errorBoundaries';


import { ToastContainer,toast } from 'react-toastify';
//import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

"use client";

import App from './App.jsx'
import 'react-toastify/dist/ReactToastify.css';
import { APP_MENU_CONFIG } from '@cores/layouts/menuConfigs';
import { validateMenuConfig } from '@cores/layouts/utils/menuConfigValidator';

if (typeof window !== 'undefined') {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.developmentModeCallback = window.Vaadin.developmentModeCallback || {};
  window.Vaadin.developmentModeCallback['vaadin-usage-statistics'] = function() {
    return false; // Tells the telemetry engine not to execute
  };
}

/**
 * main.jsx is well-structured. StrictMode for development checks is correctly placed outside the ErrorBoundary, 
 * ErrorBoundary for application-wide error handling, and ToastContainer outside the error boundary 
 * to ensure toast messages can still be displayed even if the main app crashes. 
 * This is a robust and recommended setup for modern React applications.
 * main.jsx structure looks very solid and follows best practices for a modern React application
 * 
 * 1. StrictMode: For development checks
 * 2. ErrorBoundary: For application-wide error handling, acting as a final exception handler for rendering-related JavaScript errors 
      * that occur within its descendant component tree, if those errors are not caught by a try...catch block lower down. 
      * It effectively "catches" these unhandled errors, prevents the entire application from crashing, 
      * and allows you to display a fallback UI and potentially log the error
 * 3. ToastContainer: For toast messages
 * 4. App: The main application component
 */
const errors = validateMenuConfig(APP_MENU_CONFIG);
if (errors.length > 0) {
  errors.forEach(e => {
    console.error(e); // Still a good practice to log it
    toast.error(e); // Display the error as a toast notification
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary 
      FallbackComponent={GlobalErrorFallback} 
      onError={logError} 
      onReset={resetErrorBoundary}
    >    
      <App />
    </ErrorBoundary>
    
    <ToastContainer
      slot="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </StrictMode>
);
